module.exports = __webpack_public_path__ + "static/discord-462f4ea23d6c7c7da09940e3155dfa92.svg";